module.exports = __webpack_public_path__ + "static/media/dahivada.0f477b36.jpg";